import { InjectionToken } from '@angular/core';
import {
  ApplicationConfigList,
  BaseEnv,
  BroadcastMessage,
  CookieConsent,
  FontConfig,
  Frame,
  KeycloakAuth,
  PlausibleConfig,
  ReportConfig,
  ThemeConfig
} from '@aipb/env/model';

export const APP_CONFIG = new InjectionToken<BaseEnv>('APP_CONFIG');
export const IS_PRODUCTION = new InjectionToken<boolean>('IS_PRODUCTION');
export const APP_VERSION = new InjectionToken<string>('APP_VERSION');

// Config
export const CONFIG_BROADCAST_MESSAGE = new InjectionToken<BroadcastMessage>('CONFIG_BROADCAST_MESSAGE');
export const CONFIG_PROJECT = new InjectionToken<string>('CONFIG_PROJECT');
export const CONFIG_FRAME = new InjectionToken<Frame>('CONFIG_FRAME');
export const CONFIG_GOOGLE_ANALYTICS_ID = new InjectionToken<string>('CONFIG_GOOGLE_ANALYTICS_ID');
export const CONFIG_APPLICATIONS = new InjectionToken<ApplicationConfigList>('CONFIG_APPLICATIONS');
export const CONFIG_AUTH = new InjectionToken<KeycloakAuth>('CONFIG_AUTH');
export const CONFIG_HAS_BROWSER_APP = new InjectionToken<boolean>('CONFIG_HAS_BROWSER_APP');
export const CONFIG_HAS_BROWSER_MIRADOR_APP = new InjectionToken<boolean>('CONFIG_HAS_BROWSER_MIRADOR_APP');
export const CONFIG_REPORT = new InjectionToken<ReportConfig>('CONFIG_REPORT');
export const CONFIG_THEME = new InjectionToken<ThemeConfig>('CONFIG_THEME');
export const CONFIG_FOOTER_REFERENCE = new InjectionToken<string>('CONFIG_FOOTER_REFERENCE');
export const CONFIG_COOP_ENABLED = new InjectionToken<boolean>('CONFIG_COOP_ENABLED');
export const CONFIG_OVERLAY_ENABLED = new InjectionToken<boolean>('CONFIG_OVERLAY_ENABLED');
export const CONFIG_PERSONAL_CONTENT_ENABLED = new InjectionToken<boolean>('CONFIG_PERSONAL_CONTENT_ENABLED');
export const CONFIG_PERSONAL_CONTENT_API_URL = new InjectionToken<string>('CONFIG_PERSONAL_CONTENT_API_URL');
export const CONFIG_PERSONAL_CONTENT_ADDING_NEW_ITEM_DISABLED = new InjectionToken<string>(
  'CONFIG_PERSONAL_CONTENT_ADDING_NEW_ITEM_DISABLED'
);
export const CONFIG_FONTS = new InjectionToken<FontConfig[]>('CONFIG_FONTS');
export const CONFIG_COOKIE_CONSENT = new InjectionToken<CookieConsent>('CONFIG_COOKIE_CONSENT');
export const CONFIG_PLAUSIBLE = new InjectionToken<PlausibleConfig>('CONFIG_PLAUSIBLE');
export const CONFIG_SCRIPTS = new InjectionToken<string[]>('CONFIG_SCRIPTS');

// Roles
export const ROLE_BROWSER = new InjectionToken<string>('ROLE_BROWSER');
export const ROLE_BROWSER_MIRADOR = new InjectionToken<string>('ROLE_BROWSER_MIRADOR');
export const ROLE_CATALOG = new InjectionToken<string>('ROLE_CATALOG');
export const ROLE_CATALOG_DOWNLOAD = new InjectionToken<string>('ROLE_CATALOG_DOWNLOAD');
export const ROLE_CATALOG_DOWNLOAD_INTERNAL = new InjectionToken<string>('ROLE_CATALOG_DOWNLOAD_INTERNAL');
export const ROLE_CATALOG_DOWNLOAD_BATCH = new InjectionToken<string>('ROLE_CATALOG_DOWNLOAD_BATCH');
export const ROLE_CATALOG_CAN_CROP = new InjectionToken<string>('ROLE_CATALOG_CAN_CROP');
export const ROLE_CONFIG_VIEWER = new InjectionToken<string>('ROLE_CONFIG_VIEWER');
export const ROLE_CUSTOMER_CONFIG_EDITOR = new InjectionToken<string>('ROLE_CUSTOMER_CONFIG_EDITOR');
export const ROLE_DASHBOARD = new InjectionToken<string>('ROLE_DASHBOARD');
export const ROLE_DYNAMIC_GALLERY = new InjectionToken<string>('ROLE_DYNAMIC_GALLERY');
export const ROLE_EXPLORER = new InjectionToken<string>('ROLE_EXPLORER');
export const ROLE_FULLTEXT = new InjectionToken<string>('ROLE_FULLTEXT');
export const ROLE_KEYCLOAK_MANAGER = new InjectionToken<string>('ROLE_KEYCLOAK_MANAGER');
export const ROLE_LANA = new InjectionToken<string>('ROLE_LANA');
export const ROLE_MERC = new InjectionToken<string>('ROLE_MERC');
export const ROLE_PERSONAL_CONTENT = new InjectionToken<string>('ROLE_PERSONAL_CONTENT');
export const ROLE_PERSONAL_CONTENT_COLLECTIONS = new InjectionToken<string>('ROLE_PERSONAL_CONTENT_COLLECTIONS');
export const ROLE_REPORT_TESTER = new InjectionToken<string>('ROLE_REPORT_TESTER');
export const ROLE_ZIP_MANAGER = new InjectionToken<string>('ROLE_ZIP_MANAGER');

// Local Storage
export const LOCAL_STORAGE_KEYS = new InjectionToken<string[]>('LOCAL_STORAGE_KEYS');
export const LOCAL_STORAGE_KEY_CATALOG_CASTOR_CONFIG = new InjectionToken<string>(
  'LOCAL_STORAGE_KEY_CATALOG_CASTOR_CONFIG'
);
export const LOCAL_STORAGE_KEY_CATALOG_DETAIL = new InjectionToken<string>('LOCAL_STORAGE_KEY_CATALOG_DETAIL');
export const LOCAL_STORAGE_KEY_CATALOG_FACET = new InjectionToken<string>('LOCAL_STORAGE_KEY_CATALOG_FACET');
export const LOCAL_STORAGE_KEY_CATALOG_SEARCH = new InjectionToken<string>('LOCAL_STORAGE_KEY_CATALOG_SEARCH');
export const LOCAL_STORAGE_KEY_DYNAMIC_GALLERY = new InjectionToken<string>('LOCAL_STORAGE_KEY_DYNAMIC_GALLERY');
export const LOCAL_STORAGE_KEY_EXPLORER_EXPLORATION = new InjectionToken<string>(
  'LOCAL_STORAGE_KEY_EXPLORER_EXPLORATION'
);
export const LOCAL_STORAGE_KEY_FRAME = new InjectionToken<string>('LOCAL_STORAGE_KEY_FRAME');
export const LOCAL_STORAGE_KEY_LANA_SETTINGS = new InjectionToken<string>('LOCAL_STORAGE_KEY_LANA_SETTINGS');
export const LOCAL_STORAGE_KEY_MERC_FAVORITE = new InjectionToken<string>('LOCAL_STORAGE_KEY_MERC_FAVORITE');
export const LOCAL_STORAGE_KEY_MERC_USER_FACET = new InjectionToken<string>('LOCAL_STORAGE_KEY_MERC_USER_FACET');
export const LOCAL_STORAGE_KEY_PERSONAL_CONTENT_CONFIG = new InjectionToken<string>(
  'LOCAL_STORAGE_KEY_PERSONAL_CONTENT_CONFIG'
);

// Local Storage - Fulltext
export const LOCAL_STORAGE_KEY_FULLTEXT_EDITION_TEXT_FONT_SIZE_PERCENT = new InjectionToken<string>(
  'LOCAL_STORAGE_KEY_FULLTEXT_EDITION_TEXT_FONT_SIZE_PERCENT'
);
export const LOCAL_STORAGE_KEY_FULLTEXT_EDITION_ICON_FONT_SIZE_PERCENT = new InjectionToken<string>(
  'LOCAL_STORAGE_KEY_FULLTEXT_EDITION_ICON_FONT_SIZE_PERCENT'
);
export const LOCAL_STORAGE_KEY_FULLTEXT_EDITION_ACTIVE_FONT = new InjectionToken<string>(
  'LOCAL_STORAGE_KEY_FULLTEXT_EDITION_ACTIVE_FONT'
);
